import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {PlatformLocation} from '@angular/common';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-case-practice-team-list',
  templateUrl: './case-practice-team-list.component.html',
  styleUrls: ['./case-practice-team-list.component.css'],
})
export class CasePracticeTeamListComponent implements OnInit, AfterViewInit {
  @Input() learningPathId: number;
  @Input() practiceMetaId: any;
  @Output() onGoToNextStep = new EventEmitter<any>();
  @Output() onSetMultiExerciseMetaId = new EventEmitter<any>();
  isTencent = false; // 是否腾讯对接
  practiceList: any;
  // practiceId: number;
  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  learningTour: boolean;
  chuanjie: any;
  //进入新能力考核标识
  version = 0;
  //学习 metaId
  learningPathMetaId = 0;
  //学习meta 列表
  learningPathMetas: any;
  goPostSurveyFlag: boolean;
  isOpenClass = 0;
  isShowQuestionnaire = false;
  questionnaireInfo: any = null;
  learningPathSubItems: any;

  approachTheme: any = {};
  currentIndex = 0;
  isShowApproach = false;
  isCustomLock = false;
  type: string; //是否为pc横版

  projectId: string;
  lock = false;
  isShowToast = false;
  promptText: string;

  get showGoToSurveyBtn(): boolean {
    if (Array.isArray(this.practiceList)) {
      return this.practiceList.every((item) => {
        return item.status === true;
      });
    }
  }
  constructor(
    private commonService: CommonService,
    private platformLocation: PlatformLocation,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🚚🚚🚚🚚🚚🚚');
    // -------------------------------------------------------------------
    let temp = true;
    if (this.type){
      $('#userIdContainer').val(localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))['userId'] : '');
    }
    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    localStorage.setItem('moduleId', '3');
    this.route.queryParams.subscribe(queryParams => {
      this.type = queryParams['type'];
    });

    this.projectId = localStorage.getItem('projectId');
    const projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
    if (this.projectId && projectmsg){
      projectmsg.map(item => {
        if (item.type == 4 && item.lockType == 1){
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`;
        }
      });

    }

    this.apiService
      .ajax({
        type: 'get',
        url: '/api/concatenation/' + this.learningPathId,
        data: {
          learningPathId: this.learningPathId,
        },
      })
      .subscribe((comment) => {
        this.chuanjie = comment[2].comment;
      });

    this.apiService
      .ajax({
        type: 'get',
        url: '/sr/learningtour',
      })
      .subscribe((result) => {
        this.learningPathMetas = result.learning_path_metas;
        this.learningTour =
          result.pre_survey_meta_ids.length > 0;
        this.apiService
          .ajax({
            type: 'post',
            url: '/sr/practice/createMultiExercise/' + this.learningPathId + '/' + this.practiceMetaId
          })
          .subscribe((result) => {
            console.log(result, '🍕🍕🍕🍕🍕🍕🍕🍕🍕');
            this.practiceList = result;
            //loadconfig
            this.apiService
              .loadConfig('./assets/config/practiceList.json')
              .subscribe((result) => {
                this.practiceList.forEach(function (item, index) {
                  if (result[item.title] != null) {
                    item['extends'] = result[item.title];
                  }
                });
              });

            for (let i = 0; i <= this.practiceList.length - 1; i++) {
              if (this.practiceList[i].status != true) {
                temp = false;
              }
            }
            this.finished = temp;

            this.getLearningPathMetaId();
            // this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result=>{
            //   this.questionnaireInfo = result;
            //   this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.isShow !== 1)) && this.learningPathSubItems.filter(d=>d.type === 3)[0].progress ===100 && this.learningPathSubItems.filter(d=>d.type === 4)[0].progress!==100 ? true : false;
            // });

            this.apiService
              .ajax({
                type: 'get',
                url: '/sr/onceino/115',
                data: {},
              })
              .subscribe((result) => {
                this.finishStatus = result == 1;
                setTimeout(() => {
                  if (this.finished) {
                    //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
                    if (this.version == 1) {
                      $('#surveyBtn').fadeIn(200);
                    } else {
                      $('#nextWrap').show().animate({ bottom: 0 });
                    }
                  }
                }, 1000);
              });
          });
      });
  }

  //获取进度
  getProgress(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
    }).toPromise();
  }

  //获取用户学习 metaid and version
  getLearningPathMetaId() {
    const that = this;
    this.learningPathMetas.forEach(function (item, i) {
      if (item.learningPathId == that.learningPathId) {
        if (that.type){
          $('#learningPathMetaIdContainer').val(item.id);
        }
        that.learningPathMetaId = item.id;
        that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(result => {
          that.learningPath = result;
          that.commonService.setCustomLockDate(that.learningPath, Date());
          that.learningPathSubItems = that.learningPath.subItems;
        }).then(() => {
          return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(result => {
            return that.questionnaireInfo = result;
          });
        }).then(() => {
          return that.getProgress(that.learningPathMetaId).then(result => {
            //向LMS传递进度
            if (localStorage.getItem('source_env') === 'LMS_SCORM'){
              that.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', result[0].progressList[0].progress, 'data');
            }
            return that.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'] ;
          });
        }).then(() => {
          that.approachTheme.colorSystem = 'dark';
          that.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
          that.approachTheme.currentIndex = that.currentIndex - 2;
          that.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
          that.approachTheme.btnTxt = '开启能力考核';
          that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPathSubItems.filter(d => d.type === 3)[0].progress === 100 && that.learningPathSubItems.filter(d => d.type === 4)[0].progress !== 100;
        }).then(() => {
          //增加学习断点
          that.commonService.addUserBreakPoint({'learningPathMetasId': Number(that.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': that.platformLocation['location']['href'], 'projectId': localStorage.getItem('projectId') ? localStorage.getItem('projectId') : null}).then();
          that.isCustomLock = that.learningPathSubItems[3].isLock;
          that.isShowApproach = true;
        });
        if (item.version) {
          that.version = item.version;
        }
      }
    });
  }

  getOrCreateLearningPath(learningPathMetaId){
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: 'white',
    });
  }

  goToPostSurvey() {
    if ( this.type === 'huatek'){
      this.commonService.sendPostMessage(1, 'goPostSurvey');
      return;
    }else{
      if (this.lock){
        this.showToast();
        return;
      }

      this.commonService.learningPortEventLogByCandy({'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem('userId')}).then();
      this.apiService
        .ajax({
          type: 'GET',
          url:
            '/sr/exposeoutapi/setAbilitySession/' +
            this.learningPathMetaId +
            '/4',
        })
        .subscribe((result) => {});
      const link = ['ability-survey', this.learningPathMetaId, 2];
      // let link = ["survey", this.learningPathId, 5, 1];
      // //新能力考核
      // if (this.version == 1) {
      //   link = ["ability-survey", this.learningPathMetaId, 2];
      // }
      this.router.navigate(link);
    }

  }

  showToast(){
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 2000);
  }

  finish() {
    if (this.finishStatus) {
      return;
    } else {
      //if(this.learningTour){
      this.apiService
        .ajax({
          type: 'post',
          url: '/sr/onceino/115',
          data: {},
        })
        .subscribe();
      //}
      const link = ['learning-map'];
      this.router.navigate(link);
    }
  }

  close() {
    this.apiService
      .ajax({
        type: 'get',
        url: '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId,
      })
      .subscribe((result) => {
        // 只在learningTour里出现，当完成能力是退出进入map
        if ((this.finishStatus || !this.finished) && this.learningTour) {
          const link = ['learning-map', 3];
          this.router.navigate(link);
        } else if (!this.finishStatus && this.finished && this.learningTour) {
          this.apiService
            .ajax({
              type: 'post',
              url: '/sr/onceino/115',
              data: {},
            })
            .subscribe(
              (result) => {
                const link = ['learning-map', 3];
                this.router.navigate(link);
              },
              (error) => {
                const link = ['error'];
                this.router.navigate(link);
              }
            );
        } else {
          const link = ['learning-path', result.data];
          this.router.navigate(link);
        }
      });
  }

  goToNextStep() {
    $('#exerciseMetaId').val(this.practiceList[0].exerciseMetaId);
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟1'}).then();
    if (this.practiceList[0].status) {
      const link = [
        'case-practice-team-report',
        this.practiceList[0].id,
        this.learningPathId,
        this.practiceMetaId,
      ];
      if (this.type){
        this.router.navigate(link, {queryParams: {type: 'huatek'}});
      }else{
          this.router.navigate(link);
      }
    } else {
      this.apiService
        .ajax({
          type: 'get',
          url: '/sr/onceino/401',
          data: {},
        })
        .subscribe((result) => {
          if (!result) {
            this.onGoToNextStep.emit(1);
          } else {
            this.apiService
              .ajax({
                type: 'get',
                url: '/sr/onceino/402',
                data: {},
              })
              .subscribe((result) => {
                if (!result) {
                  this.onGoToNextStep.emit(2);
                } else {
                  this.onGoToNextStep.emit(3);
                }
              });
          }
        });
    }

    this.onSetMultiExerciseMetaId.emit(this.practiceList[0].id);
  }

  closeQuestionnaire(){
    this.isShowQuestionnaire = false;
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-team-list/case-practice-team-list.component.ts